import { CatalogFilterRequest } from 'angular-api-gateway/v1/model/catalogFilterRequest';
import { CatalogItemsListingRequest } from 'angular-api-gateway/v1/model/catalogItemsListingRequest';

const CATALOG_ITEMS_LISTING_PATH: RegExp = /\/catalog\/items\/?$/;

/**
 * POST `/catalog/items` shares one pathname. Append category, page window and sort
 * so slim hydrate and fill do not share a TransferState entry. Query, ids and filters
 * are appended only when they narrow the listing.
 */
export const withCatalogListingTransferStateKey: (pathname: string, body: unknown) => string = (
  pathname: string,
  body: unknown
): string => {
  if (!CATALOG_ITEMS_LISTING_PATH.test(pathname)) {
    return pathname;
  }

  return `${pathname}|${fingerprintCatalogListingBody(body)}`;
};

const fingerprintCatalogListingBody: (body: unknown) => string = (body: unknown): string => {
  if (!body || typeof body !== 'object') {
    return '';
  }

  const request: CatalogItemsListingRequest = body as CatalogItemsListingRequest;
  const core: string = [
    String(request.categoryId ?? ''),
    String(Number(request.offset) || 0),
    String(Number(request.limit) || 0),
    request.sort?.type ?? '',
    request.sort?.order ?? '',
  ].join(':');

  const extra: string[] = [];
  const query: string = request.query ?? '';
  if (query) {
    extra.push(`q=${query}`);
  }
  if (request.ids?.length) {
    extra.push(`ids=${request.ids.join(',')}`);
  }
  const filters: string = fingerprintFilters(request.filters);
  if (filters) {
    extra.push(`f=${filters}`);
  }

  return extra.length ? `${core}|${extra.join('|')}` : core;
};

const fingerprintFilters: (filters: CatalogFilterRequest | undefined) => string = (
  filters: CatalogFilterRequest | undefined
): string => {
  if (!filters) {
    return '';
  }

  const parts: string[] = [];
  for (const item of filters.checkbox ?? []) {
    if (item.value) {
      parts.push(`cb:${item.key}`);
    }
  }
  for (const item of filters.multicheckbox ?? []) {
    if (item.valueIds?.length) {
      parts.push(`mb:${item.key}:${item.valueIds.join(',')}`);
    }
  }
  for (const item of filters.range ?? []) {
    parts.push(`rg:${item.key}:${item.min}-${item.max}`);
  }

  return parts.join(';');
};
